import { AuthWrapper } from "../../containers/wrappers/auth";

export const withAuth = (children: JSX.Element) => {
  return <AuthWrapper>{children}</AuthWrapper>;
};
